import * as React from 'react';

import { Dialog } from '@mui/material';

type ModalParams = { ModalContent: React.ReactNode; onClose?: () => void };

type ModalStore = {
    openModal: (params: ModalParams) => void;
    closeModal: () => void;
};

const defaultModalStore: ModalStore = {
    openModal: () => {},
    closeModal: () => {},
};

const ModalContext = React.createContext<ModalStore>(defaultModalStore);

export const useModalStore = (): ModalStore => {
    return React.useContext(ModalContext);
};

export const DashboardModal: React.FC<{ children: any }> = ({ children }) => {
    const [modalParams, setModalParams] = React.useState<ModalParams | null>(null);

    const closeModal = () => {
        setModalParams(null);
        modalParams?.onClose?.();
    };

    const modalStore = {
        openModal: setModalParams,
        closeModal,
    };

    return (
        <ModalContext.Provider value={modalStore}>
            {children}
            {!!modalParams && <DashboardModalOpen closeModal={closeModal} {...modalParams} />}
        </ModalContext.Provider>
    );
};

const DashboardModalOpen = ({ ModalContent, closeModal }: ModalParams & { closeModal: () => void }) => (
    <Dialog
        onClose={closeModal}
        open
        maxWidth={false}
        sx={{
            // TODO: Move the sx to the MUI theme style overrides for MuiDialog after migrating the old dialogs
            '& .MuiCardContent-root': {
                minWidth: 300,
                padding: 0,
            },
            '&:not(.NewDialog) .MuiToolbar-root': {
                padding: 0,
            },
        }}
    >
        {ModalContent}
    </Dialog>
);
